import { motion } from 'framer-motion';
import * as React from 'react';
import { useInView } from 'react-intersection-observer';

import { GridCell } from 'components/shared/grid';
import { getTextWithoutParagraph } from 'utils';

import {
  Wrapper,
  Inner,
  Grid,
  ContentLeft,
  ContentRight,
  StyledTitle,
  Description,
  BackgroundImageWrapper,
  TriangleImage,
} from './acquisition-delight.styles';
import IllustrtationActionSvgUrl from './images/illustration-action.url.svg';
import IllustrtationBusinessSvgUrl from './images/illustration-business.url.svg';
import IllustrtationContentButtonSvgUrl from './images/illustration-content-button.url.svg';
import IllustrtationContentDescSvgUrl from './images/illustration-content-desc.url.svg';
import IllustrtationContentLogoSvgUrl from './images/illustration-content-logo.url.svg';
import IllustrtationContentTitleSvgUrl from './images/illustration-content-title.url.svg';
import IllustrtationContentSvgUrl from './images/illustration-content.url.svg';
import TriangleSvgUrl from './images/solution-delight.url.svg';

export const Delight = ({ title, description }) => {
  const [animationContainer, animationContainerView] = useInView({
    threshold: 1,
  });

  const motionEase = [0.25, 0.1, 0.25, 1];

  const variantsContent = {
    hidden: {
      opacity: 0,
    },
    visible: (custom) => ({
      opacity: 1,
      clipPath: 'polygon(0 0, 0 100%, 100% 100%, 100% 0)',
      transition: { delay: custom, duration: 0.5, ease: motionEase },
    }),
  };

  const variantsContentFade = {
    hidden: {
      opacity: 0,
    },
    visible: (custom) => ({
      opacity: 1,
      transition: { delay: custom, duration: 0.5, ease: motionEase },
    }),
  };

  const variantsAction = {
    hidden: {
      opacity: 0,
    },
    visible: (custom) => ({
      opacity: 1,
      y: -50,
      transition: { delay: custom, duration: 0.5, ease: motionEase },
    }),
  };
  return (
    <Wrapper id="delight">
      <Inner>
        <Grid
          columns={2}
          gap={0}
          media={{
            md: { columns: 1 },
          }}
        >
          <GridCell>
            <ContentLeft>
              <StyledTitle
                as="h2"
                size="xl"
                dangerouslySetInnerHTML={{
                  __html: getTextWithoutParagraph(title),
                }}
              />
              <Description
                dangerouslySetInnerHTML={{
                  __html: getTextWithoutParagraph(description),
                }}
              />
            </ContentLeft>
          </GridCell>
          <GridCell>
            <ContentRight ref={animationContainer}>
              <motion.div
                className="illustration-wrapper"
                initial="hidden"
                animate={animationContainerView && 'visible'}
              >
                <motion.img
                  src={IllustrtationContentSvgUrl}
                  className="illustration-content"
                  variants={{
                    hidden: {
                      opacity: 0,
                    },
                    visible: {
                      opacity: 1,
                      y: -70,
                    },
                  }}
                  transition={{ delay: 0, duration: 0.7, ease: motionEase }}
                />
                <motion.img
                  src={IllustrtationContentTitleSvgUrl}
                  className="illustration-content-title"
                  variants={variantsContentFade}
                  custom={0.6}
                />
                <motion.img
                  src={IllustrtationContentDescSvgUrl}
                  className="illustration-content-desc"
                  variants={variantsContentFade}
                  custom={0.7}
                />
                <motion.img
                  src={IllustrtationContentLogoSvgUrl}
                  className="illustration-content-logo"
                  variants={variantsContent}
                  custom={0.8}
                />

                <motion.img
                  src={IllustrtationContentButtonSvgUrl}
                  className="illustration-content-button"
                  variants={variantsContent}
                  custom={1}
                />
                <motion.img
                  src={IllustrtationActionSvgUrl}
                  className="illustration-content-action"
                  variants={variantsAction}
                  custom={1}
                />
                <motion.img
                  src={IllustrtationBusinessSvgUrl}
                  className="illustration-content-business"
                  variants={variantsAction}
                  custom={1.5}
                />
              </motion.div>
            </ContentRight>
          </GridCell>
        </Grid>
      </Inner>
      <BackgroundImageWrapper>
        <TriangleImage src={TriangleSvgUrl} />
      </BackgroundImageWrapper>
    </Wrapper>
  );
};
